import React, { useState, useEffect } from 'react';
import './logo.css'

function Logo() {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    // Détecter les changements de taille d'écran
    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleToggleSideBar = () => {
        document.body.classList.toggle('toggle-sidebar');
    }

    return (
        <div className="d-flex align-items-center justify-content-between">
            <a href="/" className='logo d-flex align-items-center'> 
              {/* <!-- Logo --> */}
              <img src="/images/logoxx.png" alt="Logo INS" width="150" height="200" className="d-inline-block align-text-top "/>
              {/* <span className=" d-lg-block ">ANStat</span> */}
            </a>

            {/* Afficher le bouton de bascule uniquement sur les écrans larges (desktop) */}
            {windowWidth >= 1200 && (
                <i 
                    className="bi bi-list toggle-sidebar-btn hamburger-visible" 
                    onClick={handleToggleSideBar}
                    style={{
                        fontSize: '26px',
                        zIndex: 1080,
                        position: 'relative',
                        cursor: 'pointer',
                        color: '#4d6559'
                    }}
                ></i>
            )}

            {/* Bouton de bascule spécifique pour mobile */}
            {windowWidth < 1200 && (
                <i 
                    className="bi bi-list toggle-sidebar-btn mobile-toggle hamburger-visible" 
                    onClick={handleToggleSideBar}
                    style={{ 
                        fontSize: '24px', 
                        marginRight: '10px',
                        zIndex: 1080,
                        position: 'relative',
                        cursor: 'pointer',
                        color: '#4d6559'
                    }}
                ></i>
            )}
        </div>
    )
}

export default Logo
